var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"clouds"},_vm._l((_vm.images),function(cloud,index){return _c('img',{key:index,class:_vm.getRandomClasses(),style:(_vm.getRandomPosition()),attrs:{"src":require('@/assets/'+cloud+'.svg'),"alt":""}})}),0)
}
var staticRenderFns = []

export { render, staticRenderFns }